import '../styles/pages/Presence.css';
import useReveal from '../components/useReveal';

const GLOBAL_STATS = [
  { n: '33+', label: 'Countries Exporting To' },
  { n: '5',   label: 'Continents Reached' },
  { n: '48+', label: 'Years of Export Experience' },
  { n: 'MNC', label: 'Approved in Multiple Markets' },
];

const REGIONS = [
  {
    title: '🌏 Asia Pacific',
    count: '8 countries',
    countries: [
      { f: '🇧🇩', n: 'Bangladesh' }, { f: '🇰🇭', n: 'Cambodia' },
      { f: '🇮🇩', n: 'Indonesia' },  { f: '🇳🇵', n: 'Nepal' },
      { f: '🇵🇰', n: 'Pakistan' },   { f: '🇹🇭', n: 'Thailand' },
      { f: '🇦🇪', n: 'UAE' },        { f: '🇮🇳', n: 'India (Domestic)' },
    ],
  },
  {
    title: '🌍 Africa',
    count: '7 countries',
    countries: [
      { f: '🇪🇬', n: 'Egypt' },   { f: '🇪🇹', n: 'Ethiopia' },
      { f: '🇬🇭', n: 'Ghana' },   { f: '🇰🇪', n: 'Kenya' },
      { f: '🇳🇬', n: 'Nigeria' }, { f: '🇸🇩', n: 'Sudan' },
      { f: '🇹🇿', n: 'Tanzania' },
    ],
  },
  {
    title: '🌎 Latin America',
    count: '7 countries',
    countries: [
      { f: '🇦🇷', n: 'Argentina' }, { f: '🇧🇴', n: 'Bolivia' },
      { f: '🇨🇱', n: 'Chile' },     { f: '🇨🇴', n: 'Colombia' },
      { f: '🇬🇹', n: 'Guatemala' }, { f: '🇲🇽', n: 'Mexico' },
      { f: '🇵🇪', n: 'Peru' },
    ],
  },
  {
    title: '🌍 Europe',
    count: '2 countries',
    countries: [
      { f: '🇩🇪', n: 'Germany' },
      { f: '🇨🇭', n: 'Switzerland' },
    ],
  },
];

function Presence({ navigate }) {
  useReveal();

  return (
    <>
      {/* Page hero */}
      <div className="page-hero">
        <div className="page-hero-bg"></div>
        <div className="page-hero-inner">
          <div className="eyebrow">Global Presence</div>
          <h1 className="headline">
            Serving <em>33+ Countries</em> &amp; Expanding
          </h1>
          <p>
            From South America to Southeast Asia, Pharmchem's APIs are trusted by leading
            formulators across every major pharmaceutical market.
          </p>
        </div>
      </div>

      <div className="presence-page">
        <div className="presence-inner">

          {/* Stats */}
          <div className="global-stats reveal">
            {GLOBAL_STATS.map((s) => (
              <div className="gs-card" key={s.label}>
                <div className="gs-num">{s.n}</div>
                <div className="gs-label">{s.label}</div>
              </div>
            ))}
          </div>

          {/* Regions */}
          <div className="regions">
            {REGIONS.map((r) => (
              <div className="region reveal" key={r.title}>
                <div className="region-header">
                  <div className="region-title">{r.title}</div>
                  <span className="region-count">{r.count}</span>
                </div>
                <div className="countries-wrap">
                  {r.countries.map((c) => (
                    <div className="country-pill" key={c.n}>
                      <span className="country-flag">{c.f}</span>
                      {c.n}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="cta-band presence-cta">
            <h2>Want to Import from Pharmchem?</h2>
            <p>We're actively expanding our export network. Reach out to our export team today.</p>
            <div className="cta-band-actions">
              <button className="btn btn-white" onClick={() => navigate('contact')}>
                Contact Export Team
              </button>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default Presence;
